import { ServiceSubCategory, serviceType } from '@/commonTypes';
import React, { cloneElement, isValidElement } from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { avatarBg } from '@/functions/formats';
import PageCard from '@/components/general/PageCard';

export default function ViolationSummary({ data }: { data?: ServiceSubCategory }) {
  let list = [
    {
      icon: <MainIcons.coinIcon />,
      label: 'مجموع خلافی',
      value: data?.response?.inquire_price
        ? Number(data?.response?.inquire_price)?.toLocaleString()
        : '0',
      unit: 'ریال',
      color: 'var(--danger)',
      bg: avatarBg(7),
    },
    {
      icon: <MainIcons.flashIcon />,
      label: 'تعداد موارد',
      value: data?.items_count ? data?.items_count : 0,
      unit: 'مورد',
      color: 'var(--brand-deep)',
      bg: avatarBg(6),
    },
    // {
    //   icon: <MainIcons.shieldIcon />,
    //   label: 'امتیاز منفی',
    //   value: '۱۰',
    //   unit: 'امتیاز',
    //   color: 'var(--accent-deep)',
    //   bg: avatarBg(8),
    // },
  ];
  console.log('summary========', data);
  return (
    <div className={`${styles.container}`}>
      {list?.map((item, index) => (
        <PageCard
          key={index}
          title={item?.label}
          icon={
            isValidElement(item?.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
              ? cloneElement(item?.icon, {
                  fill: item?.color,
                  width: `${'16px'}`,
                  height: `${'16px'}`,
                })
              : item?.icon
          }
          backgroundIcon={item?.bg}
          className={`${styles.summaryItem}`}
          titleClass={`${styles.title}`}
          aside={
            <div className={`${styles.aside}`}>
              <div className={styles.chipValue} style={{ color: item?.color }}>
                {item?.value}
                <span className={styles.chipUnit}>{item?.unit}</span>
              </div>
            </div>
          }
        />
      ))}
    </div>
  );
}
